export default __webpack_public_path__ + "static/media/code.078c7fc2.svg";